import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { ConstantFormat } from "../../../../../../../utils/DateFns";
import { CellContentRoot } from "..";

const ClosedTimeCellContent: React.FC<ClosedTimeCellContent.Props> = ({
	item,
}) => {
	const { dateFns } = useAppContext();

	const content = useMemo(() => {
		const content = item?.closedAt
			? dateFns.formatTime(item.closedAt, {
					formatTime: ConstantFormat.MDYHM_UK,
					timezone: dateFns.timezone,
					isZeroSeconds: true,
					isTimezone: true,
			  })
			: "";

		return content;
	}, [dateFns, item?.closedAt]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ClosedTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ClosedTimeCellContent;
